/**
 * The card chrome both of this report's card rows use — one divided surface, not six tiles.
 * Why it is shaped this way: `design-notes.md`.
 */

import { Card } from '@/components/ui/card';

// Hairlines are the grid background through a 1px gap, not `divide-x`, which breaks on wrap.
const SEGMENT_GRID = 'grid gap-px bg-border sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6';

/** One segment. `bg-card` is what leaves only the gap showing — it is structural, not decoration. */
export const SEGMENT = 'flex flex-col bg-card px-3 py-1.5';

export function SegmentCard({ children }: { children: React.ReactNode }) {
  return (
    <Card className="gap-0 overflow-hidden py-0">
      <div className={SEGMENT_GRID}>{children}</div>
    </Card>
  );
}
